const PREFIX = 'savedRole#';

/** Exported for prefix Queries (e.g. the alert matcher listing a user's watched roles). */
export const SAVED_ROLE_ITEM_KEY_PREFIX = PREFIX;

/**
 * Watched-role UserState key: the suffix is the localized normalisedTitle
 * exactly as the jobs index facets it (case-sensitive — facet matching is
 * exact). Titles never legitimately contain '#'.
 */
export function buildSavedRoleItemKey(roleTitle: string): `savedRole#${string}` {
  return `${PREFIX}${roleTitle}`;
}

/** Extracts the role title from a `savedRole#{title}` UserState item key. Null if malformed. */
export function parseSavedRoleItemKey(itemKey: string): string | null {
  if (!itemKey.startsWith(PREFIX) || itemKey.length <= PREFIX.length) return null;
  return itemKey.slice(PREFIX.length);
}
